import axios from "axios";

const instance = axios.create({
  baseURL: "https://node.rxchartsquare.com/",
  // baseURL: "https://node.yahuplus.in",
});

export default instance;
